import React from "react";
import { UserAuth } from "../context/AuthContext";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import "./MainView.css"
import { useState } from "react";

export const MainView = () => {
  const { logout } = UserAuth();
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login");
      console.log("You are logged out");
    } catch (e) {
      console.log(e.message);
    }
  };

  return (
    // main container
    <div className="main-container">
        <div className={expanded ? "sidebar" : "sidebarNotExpanded"}  onMouseOver={() => setExpanded(true)} onMouseLeave={() => setExpanded(false)} style={{ transition: 'width 0.5s' }}>
          <Sidebar logout={handleLogout} showTitles={expanded}/>
        </div>
        {/* content */}
        <div className={expanded ? "content" : "contentNotExpanded"} style={{ transition: 'width 0.5s' }}>
          {/* contentBox */}
          <div className="contentBox">
            {/* header */}
            <div className="header">
              <Header/>
            </div>
            <div className="screen">
              <Outlet />
            </div>
          </div>
        </div>
    </div>
  );
};
